export default __webpack_public_path__ + "images/328d81628ea4a7fb2f9c68b8e959c8b5.png";